import { useCallback, useMemo } from 'react'
import { Gauge } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchRateLimits, DEV_STR as S, type RateLimitRow } from './devApi'

/**
 * A13.04 — Лимиты запросов (rate-limit tiers, read-only). Dormant until
 * `/admin/developers/rate-limits` ships. Placeholder permission USERS_VIEW.
 */
export function RateLimitsScreen() {
  const columns = useMemo<AdminColumn<RateLimitRow>[]>(
    () => [
      { key: 'tier', header: S.tier, type: 'text' },
      { key: 'per_minute', header: S.perMinute, type: 'number' },
      { key: 'burst', header: S.burst, type: 'number' },
      { key: 'applies_to', header: S.appliesTo, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchRateLimits, [])
  return (
    <>
      <PageHeader title={S.rateLimits} screenId="A13.04" />
      <DataTable<RateLimitRow>
        screenId="A13.04"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Gauge size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
